import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

function Seo({
  canonical,
  title,
  description,
  lang,
  article,
  meta,
}) {
  const { site } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title,
          description,
        }
      }
    }
  `)

  const metaTitle = title || site.siteMetadata.title
  const metaDescription = description || site.siteMetadata.description
  const metaArticle = article
  const metaCanonical = `https://dreyerinjurylaw.com/${canonical}`

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={
        canonical ? [{ rel: "canonical", key: metaCanonical, href: metaCanonical}] : [{ rel: "canonical", key: "https://dreyerinjurylaw.com", href: "https://dreyerinjurylaw.com"}]
      }
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: metaArticle,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  article: `website`,
  meta: [],
}

Seo.propTypes = {
  canonical: PropTypes.string,
  description: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
}

export default Seo